'use client';

import { Text } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import { DOWNLOAD_REVIEWS } from '../../download/download-copy';
import { StarRow } from './RatingSummary';

/**
 * Production's member reviews, in production's order. The same fixed list
 * renders for every member; the text comes from the catalog only.
 */
export function ReviewList() {
  const { t } = useTranslation('signup');
  return (
    <ul
      className="signup-download__reviews"
      aria-label={t('download.reviews.label')}
      data-testid="signup-download-reviews"
    >
      {DOWNLOAD_REVIEWS.map((review) => (
        <li
          key={review.id}
          className="signup-download__card signup-download__review"
          data-testid="signup-download-review"
        >
          <StarRow value={5} />
          <Text variant="b2Bold" value={t(review.title)} />
          <Text variant="b3Regular" color="secondary" value={t(review.body)} />
        </li>
      ))}
    </ul>
  );
}
